import { render, staticRenderFns } from "./DashboardEmpty.vue?vue&type=template&id=feb02e74&"
import script from "./DashboardEmpty.vue?vue&type=script&lang=ts&"
export * from "./DashboardEmpty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports